import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  GET_ATTACHMENT_CATEGORY_TYPE_DATA,
  ADD_ATTACHMENT_CATEGORY_TYPE,
  DELETE_ATTACHMENT_CATEGORY_TYPE,
  UPDATE_ATTACHMENT_CATEGORY_TYPE,
} from "./actionTypes";

import {
  getAttachmentCategoryTypeDataSuccess,
  getAttachmentCategoryTypeDataFail,
  addAttachmentCategoryTypeSuccess,
  addAttachmentCategoryTypeFail,
  deleteAttachmentCategoryTypeSuccess,
  deleteAttachmentCategoryTypeFail,
  updateAttachmentCategoryTypeSuccess,
  updateAttachmentCategoryTypeFail,
} from "./actions";

import {
  getAttachmentCategoryTypeList,
  addAttachmentCategoryTypeApiCall,
  deleteAttachmentCategoryTypeApiCall,
  updateAttachmentCategoryTypeApiCall,
} from "../../helpers/fakebackend_helper";

//*****************************  Attachment Category Type CRUD Saga  *********************************//

// get attachment category type data "Read"
function* fetchAttachmentCategoryTypeData() {
  try {
    const response = yield call(getAttachmentCategoryTypeList);
    yield put(getAttachmentCategoryTypeDataSuccess(response));
  } catch (error) {
    yield put(getAttachmentCategoryTypeDataFail(error));
  }
}

export function* watchFetchAttachmentCategoryTypeData() {
  yield takeEvery(
    GET_ATTACHMENT_CATEGORY_TYPE_DATA,
    fetchAttachmentCategoryTypeData
  );
}

// Add Attachment Category Type

function* addAttachmentCategoryType({ payload }) {
  try {
    const response = yield call(addAttachmentCategoryTypeApiCall, payload);
    yield put(addAttachmentCategoryTypeSuccess(response));
  } catch (error) {
    yield put(addAttachmentCategoryTypeFail(error));
  }
}

export function* watchAddAttachmentCategoryType() {
  yield takeEvery(ADD_ATTACHMENT_CATEGORY_TYPE, addAttachmentCategoryType);
}

// Update Attachment Category Type

function* updateAttachmentCategoryType({ payload }) {
  try {
    const response = yield call(updateAttachmentCategoryTypeApiCall, payload);
    yield put(updateAttachmentCategoryTypeSuccess(response));
  } catch (error) {
    yield put(updateAttachmentCategoryTypeFail(error));
  }
}

export function* watchUpdateAttachmentCategoryType() {
  yield takeEvery(
    UPDATE_ATTACHMENT_CATEGORY_TYPE,
    updateAttachmentCategoryType
  );
}

// Delete Attachment Category Type

function* deleteAttachmentCategoryType({ payload }) {
  try {
    const response = yield call(deleteAttachmentCategoryTypeApiCall, payload);
    yield put(deleteAttachmentCategoryTypeSuccess(response));
  } catch (error) {
    yield put(deleteAttachmentCategoryTypeFail(error));
  }
}

export function* watchDeleteAttachmentCategoryType() {
  yield takeEvery(
    DELETE_ATTACHMENT_CATEGORY_TYPE,
    deleteAttachmentCategoryType
  );
}

// main saga function
function* attachmentCategoryTypeSaga() {
  yield all([
    fork(watchFetchAttachmentCategoryTypeData),
    fork(watchAddAttachmentCategoryType),
    fork(watchUpdateAttachmentCategoryType),
    fork(watchDeleteAttachmentCategoryType),
  ]);
}

export default attachmentCategoryTypeSaga;
